module.exports = __webpack_public_path__ + "img/1232062366.38900a70.jpg";